import {guid} from './utils';
import {listen} from './lib/navigator';
import {isWebWorker, provideBrowsingContext} from './lib/env';
import {getDesktopSize, getWindowSize} from './lib/screen';

const IS_TRACKING = '__isTrackingBiBrowsingSession__';
const ENDPOINT = 'p';
const SOURCE = 19;
const EVID = 3;

function shouldTrack() {
  return !isWebWorker() && provideBrowsingContext(window => !window[IS_TRACKING]);
}

function setIsTracking() {
  return provideBrowsingContext(window => window[IS_TRACKING] = true);
}

function getLogger(loggerFactory) {
  return loggerFactory({endpoint: ENDPOINT, useBeacon: true})
    .setDefaults({src: SOURCE, evid: EVID, vsi: guid()})
    .logger();
}

function trackBrowsingSession(loggerFactory) {
  const logger = getLogger(loggerFactory);
  let firstInSession = 1;

  listen((fromUrl, toUrl) => {
    const {sr, wr} = provideBrowsingContext(window => ({sr: getDesktopSize(window), wr: getWindowSize(window)}));

    logger.log({from: fromUrl, to: toUrl, fis: firstInSession, sr, wr});
    firstInSession = 0;
  });
}

/**
 * Sends a page view event on initial load and on every page switch
 * BI event definition: http://bo.wix.com/bi-catalog-webapp/#/sources/19/events/3
 */
export function track(loggerFactory) {
  if (shouldTrack()) {
    setIsTracking();
    trackBrowsingSession(loggerFactory);
  }
}



// WEBPACK FOOTER //
// ./browsingSession.js